import * as THREE from 'three'

export default class Smoke extends THREE.Object3D {
  constructor(scene, options) {
    super()
    this.scene = scene;
    this.clock = new THREE.Clock();

    this.setup();
  }
  setup() {
    THREE.ImageUtils.crossOrigin = ''
    this.smokeTexture = THREE.ImageUtils.loadTexture(require('@/assets/images/smoke-element.png'));
    this.smokeMaterial = new THREE.MeshLambertMaterial({
      color: 0xffffff,
      map: this.smokeTexture,
      transparent: true,
      opacity: 0.4
    });
    this.smokeGeo = new THREE.PlaneGeometry(400,400);
    this.smokeParticles = [];

    for (let p = 0; p < 50; p++) {
        var particle = new THREE.Mesh(this.smokeGeo,this.smokeMaterial);
        particle.position.set(Math.random() * 500 - 250, Math.random() * 500 - 250, Math.random() * 1000 - 100);
        particle.rotation.z = Math.random() * 360;
        this.scene.add(particle);
        this.smokeParticles.push(particle);
    }
  }
  evolveSmoke(delta){
    var sp = this.smokeParticles.length;
    while(sp--) {
        this.smokeParticles[sp].rotation.z += (delta * 0.2);
    }
  }
  update(time) {
    let delta = this.clock.getDelta()
    this.evolveSmoke(delta);
  }
}
